import type { DecisionLog, LmRunLog } from '@super/shared-types'
import {
  GRAPH_DECISION_SUMMARIES,
  GRAPH_RUN_SUMMARIES,
  isGraphDecisionType,
  isGraphRunType,
} from '@super/shared-types'

/** The one sentence a graph run row carries, or null for any other run. */
export function runSummaryOf(run: LmRunLog): string | null {
  if (!isGraphRunType(run.promptType)) return null
  return GRAPH_RUN_SUMMARIES[run.promptType](run.inputContext, run.actualOutput)
}

/** The one sentence a graph decision row carries, or null for any other decision. */
export function decisionSummaryOf(decision: DecisionLog): string | null {
  if (!isGraphDecisionType(decision.decisionType)) return null
  return GRAPH_DECISION_SUMMARIES[decision.decisionType](
    decision.inputs,
    decision.outcome,
  )
}

export function GraphRowSummary({ text }: { text: string }) {
  return <p className="text-sm text-foreground mb-2 leading-snug">{text}</p>
}
